import {
  NavigationContainerRefWithCurrent,
  ParamListBase,
} from "@react-navigation/core";
import { atom } from "jotai";

export const navigationRef_atom =
  atom<null | NavigationContainerRefWithCurrent<ParamListBase>>(null);

export const NoNav_atom = atom<boolean | null>(false);
